import { Component, OnInit } from '@angular/core';
import {Registration} from '../shared/classes/Registration';
import {RegistrationService} from '../shared/services/registrationService/registration.service';
import {PayService} from '../shared/services/payService/pay.service';

@Component({
  selector: 'app-recapitulation',
  templateUrl: './recapitulation.component.html',
  styleUrls: ['./recapitulation.component.css']
})
export class RecapitulationComponent implements OnInit {

  registration: Registration;
  allow = false;

  constructor(private registrationService: RegistrationService,
              private payService: PayService) {
    this.registration = this.registrationService.registration;
  }

  ngOnInit() {
  }

  allowPay(value) {
    this.payService.allow = value;
  }

}
